import { useQuery } from '@tanstack/react-query';
import { getOrganizationWorkspaceDetails } from './organizations.utils';

const FIFTEEN_MINUTES = 15 * 60 * 1000;

// useOrganization fetches the same endpoint and seeds this key, so the two never both request it.
export function workspaceQueryKey(workspaceId: string | undefined) {
  return ['workspace', { workspaceId }] as const;
}

export function useWorkspace(workspaceId: string | undefined) {
  return useQuery({
    queryKey: workspaceQueryKey(workspaceId),
    queryFn: () => getOrganizationWorkspaceDetails(workspaceId as string),
    enabled: Boolean(workspaceId),
    staleTime: FIFTEEN_MINUTES,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
